/**
 * The key that marks a JS bundle as first-party code in Sentry events.
 *
 * The Vite build stamps every bundle with this key (see our use of `sentryVitePlugin`)
 * so the `thirdPartyErrorFilterIntegration` (used in `sentry.config.js`) can detect
 * stack frames that come from code not in our vite bundles, such as browser extensions.
 */
export const SENTRY_APPLICATION_KEY = "silverside";
